import { OralExamPauseReason } from '@/common/api/models/oralExamPauseReason';
import { OralExamSupervisorStatus } from '@/common/api/models/oralExamSupervisorStatus';

export type SupervisorEngagedLecturerPauseInput = {
  isPaused?: boolean | null;
  pauseReason?: OralExamPauseReason | null;
  supervisorStatus?: OralExamSupervisorStatus | null;
};

/**
 * True when the lecturer opened Engage on this booking while the exam is
 * paused: lecturer_pause (cold engage) or help_requested still open after
 * help Engage (drop-in does not restack pauses). Relocates the pause cue into
 * the supervision panel (student) and keeps the tile on-track (lecturer).
 */
export function isSupervisorEngagedLecturerPause({
  isPaused,
  pauseReason,
  supervisorStatus,
}: SupervisorEngagedLecturerPauseInput): boolean {
  if (isPaused !== true || supervisorStatus !== OralExamSupervisorStatus.engaged) {
    return false;
  }
  return pauseReason === OralExamPauseReason.lecturer_pause
    || pauseReason === OralExamPauseReason.help_requested;
}
